import React from 'react';
import {
  ArrayInput,
  Create,
  FormDataConsumer,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
} from 'react-admin';
import ImageInput from '../../../commonComponents/UploadInputs/ImageInput';
import { s3FilePaths } from '../../../config/constants';

const SimulatorReactionsCreate = (props) => (
  <Create title="Create reaction pack" undoable={false} {...props}>
    <SimpleForm redirect="list">
      <TextInput label="Name" source="name" validate={required()} />
      <ArrayInput source="images">
        <SimpleFormIterator>
          <FormDataConsumer>
            {({ getSource }) => (
              <ImageInput
                label="Image"
                imageInputSource={getSource('image')}
                imagePath={s3FilePaths.allUploads}
                validate={required()}
              />
            )}
          </FormDataConsumer>
          <ReferenceInput label="Type" source="type_id" reference="admin/reactions/types">
            <SelectInput optionText="id" />
          </ReferenceInput>
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
);

export default SimulatorReactionsCreate;
